import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CacheService } from '@delon/cache';
import { AppService } from '@root/app.service';
import { Observable } from 'rxjs';

export enum Page {
  Dashboard = 'dashboard',
  Inbox = 'inbox',
  Tasks = 'tasks',
  Review = 'review',
  Automation = 'automation',
  Guest = 'guest',
  Calendar = 'calendar',
  Price = 'price',
}

@Injectable({
  providedIn: 'root',
})
export class NoDataService {
  constructor(private http: HttpClient, private cache: CacheService, private app: AppService) {}

  #hasChannelAccount = false;

  #hasLinkedListings = false;

  private fetchConfigInfo() {
    return this.http.get('/api/config/onboarding');
  }

  private fetchTaskOverview() {
    return this.http.get('/api/schedule/task/overview');
  }

  private getPageKey(page: Page): string {
    const account = this.app.user?.account;
    return `${account}_${page}_demo_hiden`;
  }

  /**
   * 前端是否隐藏demo
   * 当显示过正常数据之后，前端将记录，之后不再展示demo
   */
  private isFrontHideDemo(page: Page): boolean {
    return this.cache.getNone(this.getPageKey(page));
  }

  get hasChannelAccount() {
    return this.#hasChannelAccount;
  }

  get hasLinkedListings() {
    return this.#hasLinkedListings;
  }

  checkShouldShowDemo(page: Page): Observable<boolean> {
    return new Observable((observer) => {
      this.fetchConfigInfo().subscribe((rst: any) => {
        const hasAccount = rst?.data?.has_channel_account;
        const hasListings = rst?.data?.has_linked_listing;

        const hideDemo = this.isFrontHideDemo(page);

        this.#hasChannelAccount = hasAccount;
        this.#hasLinkedListings = hasListings;

        if ([Page.Calendar, Page.Inbox, Page.Price, Page.Dashboard].indexOf(page) > -1) {
          /**
           * 这几个页面特殊处理，需要检查渠道账号数和关联房源数。这两个数量满足任意一个为空的时候，就需要展示demo页面
           */
          observer.next((!hasAccount || !hasListings) && !hideDemo);
        } else {
          /**
           * 其他页面不需要检查关联房源数量
           */
          observer.next(!hasAccount && !hideDemo);
        }
        observer.complete();
      });
    });
  }

  checkTasksShouldShowDemo(page: Page): Observable<boolean> {
    return new Observable((observer) => {
      this.fetchTaskOverview().subscribe((rst: any) => {
        const hasTasks = rst?.data?.exist_tasks;
        const hideDemo = this.isFrontHideDemo(page);

        observer.next(!hasTasks && !hideDemo);
        observer.complete();
      });
    });
  }

  /**
   * 前端隐藏demo
   * 隐藏之后，就不再展示demo
   */
  frontHideDemo(page: Page) {
    this.cache.set(this.getPageKey(page), true);
  }
}
